import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { CountDownTimer } from '../CountdownTimer/CountdownTimer';
import { countdownCardStyles } from './countdownCardStyles';
import { useTheme } from '@mui/material/styles';
import { ASSETS_PATH } from '../../services/endpoints';
import { useEffect, useState } from 'react';

export interface ICountDownCardTimerProps {
  index: number;
  onPartyTime: () => void;
  endDate: string;
}

export const CountDownCardTimer = ({
  index,
  onPartyTime,
  endDate
}: ICountDownCardTimerProps) => {
  const theme = useTheme();
  const imagePath = `${ASSETS_PATH}/img/brickken_shape_svg.svg`;
  const classes = countdownCardStyles(theme, imagePath);

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const target = new Date(endDate);

    const interval = setInterval(() => {
      const now = new Date();
      const difference = target.getTime() - now.getTime();

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      setDays(d);

      const h = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHours(h);

      const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      setMinutes(m);

      const s = Math.floor((difference % (1000 * 60)) / 1000);
      setSeconds(s);

      if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
        onPartyTime();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Grid item justifyContent='center' width='100%' height='100%'>
      <Box sx={classes.countdownContainer}>
        <Box sx={classes.countdownMask} />
        <CountDownTimer
          round={index}
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
        />
      </Box>
    </Grid>
  );
};
